<template>
  <div id="redirectLogin">
    <div class="imgBgSSO">
      <div class="loginSSo">
        <div>
          登录中...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'redirectLogin',
  data () { // 所有的数据都写在里面
    return {
      gskToken: localStorage.gskToken || '',
      queryCode: this.$route.query.code || ''
    }
  },
  created () {
    // this.goUrl()
  },
  methods: {// 所有的方法写在里面
    goUrl () {
      if (!this.gskToken) {
        this.$axiox.post('/api/GetUserByCode?code=' + this.queryCode).then(msg => {
          let newToken = msg.data.jwtToken || ''
          let gskloginInfo = msg.data || {}
          if (newToken) {
            localStorage.gskToken = newToken
            localStorage.gskloginInfo = JSON.stringify(gskloginInfo)
            this.$router.push({
              name: 'myHome'
            })
          }
        })
      } else {
        this.$router.push({
          name: 'myHome'
        })
      }
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.imgBgSSO{
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.loginSSo{
  margin-left: 46%;
  min-width: 300px;
  z-index: 2;
  background: #fff;
  padding: 20px;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/redirectLogin.vue